import { combineReducers } from "redux";
import common from "./common";
import menus from "../../containers/Sidebar/state/reducer";
import consignedOrder from "../../containers/ConsignedOrder/state/reducer";
import partners from "../../containers/Partners/state/reducer";
import ezdParameters from "../../containers/EZDParameters/state/reducer";
import products from "../../containers/Products/state/reducer";
import sellableProduct from "../../containers/SellableProduct/state/reducer";
import accountBalance from "../../containers/AccountBalance/state/reducer";
import monthLock from "../../containers/MonthLocks/state/reducer";
import paymentTerms from "../../containers/PaymentTerms/state/reducer";
import ingestionMonitor from "../../containers/IngestionMonitor/state/reducer";
import rollbackIngestion from "../../containers/RollbackIngestion/state/reducer";
import wsPartners from "../../containers/WSPartners/state/reducer";

const reducers = {
  common,
  menus,
  consignedOrder,
  partners,
  ezdParameters,
  products,
  sellableProduct,
  accountBalance,
  monthLock,
  paymentTerms,
  ingestionMonitor,
  rollbackIngestion,
  wsPartners
};

const combinedReducers = Object.keys(reducers).length
  ? { ...reducers }
  : {
      default: (state) => (state == null ? (state = []) : state),
    };

export default combineReducers(combinedReducers);
